export default __webpack_public_path__ + "static/calidad-fd7f88e1cc251c37153cff9d7d07fb83.png";